var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0214 5.70348L17.9577 5.58488L17.8625 5.68006L17.152 6.39068L17.1014 6.44127L17.133 6.50548C17.6525 7.56298 17.9527 8.74557 17.9527 9.99978V10.4735V10.5735H18.0527H19H19.1V10.4735V9.99978C19.1 8.44619 18.7082 6.98322 18.0214 5.70348ZM13.4943 2.86731L13.569 2.90409L13.6146 2.84283L14.32 2.13745L14.4151 2.04233L14.2966 1.97865C13.0168 1.29082 11.5549 0.9 10.0003 0.9C4.97404 0.9 0.9 4.97412 0.9 10.0003V10.474V10.574H1H1.94749H2.04749V10.474V10.0003C2.04749 5.61521 5.61509 2.04765 10.0001 2.04765C11.2544 2.04765 12.4377 2.34698 13.4943 2.86731ZM17.0372 3.77407L16.9665 3.70336L17.0372 3.77406C17.2611 3.55023 17.2611 3.1867 17.0372 2.96287L16.9665 3.03358L17.0372 2.96287C16.8134 2.73905 16.4499 2.73905 16.226 2.96287L9.59434 9.59441L9.66505 9.66512L9.59434 9.59441C9.37052 9.81824 9.37052 10.1818 9.59434 10.4056L9.5944 10.4057C9.70669 10.5178 9.85354 10.5741 10.0005 10.5741C10.1466 10.5741 10.2936 10.5177 10.4057 10.4056L17.0372 3.77407Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.113d14df5d2b2d17f8c366c8b7a1a64b.svg";
export { ForwardRef as ReactComponent };